export const getContent = store => (store.invoice ? store.invoice : {});
export const get = store => {
  return getContent(store).invoice;
};
export const isLoaded = store => {
  let content = getContent(store);
  return content.isLoaded != null && content.isLoaded;
};
